import {createSlice} from "@reduxjs/toolkit";

const initialHTML5GamesWiseJoiningListState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  html5GamesCategories: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const HTML5GameWiseJoiningListSlice = createSlice({
  
  name: "html5GamesList",
  initialState: initialHTML5GamesWiseJoiningListState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    
    html5GamesWiseJoiningList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    html5GamesWiseListExport: (state, action) => {
      const { exportData } = action.payload;
      state.exportData = exportData;
    }
  }
});
